/**
 * App-instance "active" is a portfolio status, not a health claim.
 * Same definition on Overview and App Instances: status=active and not expired.
 */

export type AppInstanceStatusInput = {
  status?: string;
  environment?: string;
  sandbox_config?: { expires_at?: string } | null;
};

export function isSandboxExpired(app: AppInstanceStatusInput): boolean {
  if (String(app?.environment || '') !== 'sandbox') return false;
  const expiresAt = app?.sandbox_config?.expires_at;
  if (!expiresAt) return false;
  const ts = new Date(expiresAt).getTime();
  return Number.isFinite(ts) && ts < Date.now();
}

export function isAppActive(app: AppInstanceStatusInput): boolean {
  if (isSandboxExpired(app)) return false;
  return String(app?.status || '').toLowerCase() === 'active';
}
